/**
 * Whether a nav entry is the page you're on: its own address or one under it.
 * Home, the platform console and an assistant's Executives only on their own
 * address, since other entries sit under them (so only one entry says "this
 * page" to a screen reader).
 */
export function isNavItemCurrent(itemPath: string, pathname: string): boolean {
  const path = pathname.toLowerCase().replace(/\/+$/, '') || '/';
  if (itemPath === '/' || itemPath === '/platform' || itemPath === '/assistant') return path === itemPath;
  return path === itemPath || path.startsWith(`${itemPath}/`);
}

/**
 * What AppLayout rebuilds the routed page on. A page of sections or tabs
 * (Organisation, Settings, Review, Insights, Focus, Drivers, Executive
 * profiles) keeps one key across them, so choosing one doesn't rebuild the
 * list and take keyboard focus off the link just chosen (and Insights keeps
 * what it has loaded). Each page swaps its own tab's content.
 */
export function routeRemountKey(pathname: string): string {
  const sections = /^\/(organisation|settings|review|insights|focus|drivers|assistant\/profiles)(\/[^/]*)?\/?$/i.exec(pathname);
  return sections ? `/${sections[1].toLowerCase()}` : pathname;
}
